/**
 * @generated SignedSource<<ccae1f2a7bd4e686149bf6f186708c88>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type storeCatalogQuery$variables = {
  salesChannelID: string;
};
export type storeCatalogQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"storeCatalogPaginationFragment__merchantProducts">;
};
export type storeCatalogQuery = {
  response: storeCatalogQuery$data;
  variables: storeCatalogQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "salesChannelID"
  }
],
v1 = {
  "kind": "Variable",
  "name": "salesChannelID",
  "variableName": "salesChannelID"
},
v2 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 20
  },
  (v1/*:: as any*/),
  {
    "kind": "Literal",
    "name": "search",
    "value": ""
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "storeCatalogQuery",
    "selections": [
      {
        "args": [
          (v1/*:: as any*/)
        ],
        "kind": "FragmentSpread",
        "name": "storeCatalogPaginationFragment__merchantProducts"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "storeCatalogQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*:: as any*/),
        "concreteType": "MerchantProductsConnection",
        "kind": "LinkedField",
        "name": "merchantProducts",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "MerchantProductsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "MerchantProduct",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "sku",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "thumbnail",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "KeyValuePairOfStringAndString",
                    "kind": "LinkedField",
                    "name": "metadata",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "key",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "value",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isConfiguratedInZakeke",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v2/*:: as any*/),
        "filters": [
          "search",
          "salesChannelID"
        ],
        "handle": "connection",
        "key": "storeCatalogPaginationFragment_merchantProducts",
        "kind": "LinkedHandle",
        "name": "merchantProducts"
      }
    ]
  },
  "params": {
    "cacheID": "f7845259ac5723fd2dc9c98a63d7b262",
    "id": null,
    "metadata": {},
    "name": "storeCatalogQuery",
    "operationKind": "query",
    "text": "query storeCatalogQuery(\n  $salesChannelID: ID!\n) {\n  ...storeCatalogPaginationFragment__merchantProducts_2P2j2V\n}\n\nfragment storeCatalogPaginationFragment__merchantProducts_2P2j2V on Query {\n  merchantProducts(first: 20, search: \"\", salesChannelID: $salesChannelID) {\n    edges {\n      node {\n        id\n        sku\n        name\n        thumbnail\n        metadata {\n          key\n          value\n        }\n        isConfiguratedInZakeke\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "1e962e1e1f30e464f08a2d83126bcd3d";

export default node;
